module.exports = __webpack_public_path__ + "static/media/archer_drone_default.9cb74a1b.svg";